export { default } from './AIInsights';
